var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var gql = String.raw;
export var AllCitations = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  allCitations {\n    ...EntityListFields\n    authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n    type { name id }\n    topics { id name slug path __typename _schema { label pluralLabel } }\n    trends { id name slug path __typename _schema { label pluralLabel } }\n  }\n"], ["\n  allCitations {\n    ...EntityListFields\n    authors { id name slug } authorShowsEtAl edition publication date accessDate startPage volume footnoteNumber year\n    type { name id }\n    topics { id name slug path __typename _schema { label pluralLabel } }\n    trends { id name slug path __typename _schema { label pluralLabel } }\n  }\n"])));
var templateObject_1;